<template>
    <div class="tq-header-back">
      <div class="left-back_wrap" @click="goBack">
        <div class="back-svg">
          <img src="./icon/icon_back.svg" alt="">
        </div>
        <div class="back-text text-medium">
          <span>返回</span>
        </div>
      </div>
      <template v-if="extraTitle">
        <div class="sperate-line-header-back"></div>
        <div class="back-text text-medium">
          <span>{{extraTitle}}</span>
        </div>
      </template>
      <div style="flex: 1;">
        <slot name="operate"></slot>
      </div>
    </div>
</template>

<script lang="ts">
export default {
  name: "TqHeaderBack",
    data() {
        return {

        }
    },
    props: {
      extraTitle: {
        type: String,
        default: ''
      }
    },
    methods: {
      goBack(){
        this.$emit('goBack')
      }
    }
}
</script>
